import { render } from "./StampModal.vue?vue&type=template&id=08cbba6a&scoped=true"
import script from "./StampModal.vue?vue&type=script&lang=js"
export * from "./StampModal.vue?vue&type=script&lang=js"

import "./StampModal.vue?vue&type=style&index=0&id=08cbba6a&rel=scss&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08cbba6a"]])

export default __exports__